export class MeasurementRequestViewModel {

	locationId?: string;
	zoneId?: string;
	structureId?: string;
	deviceId: string;

	constructor(locationId?: string, zoneId?: string, structureId?: string, deviceId?: string) {
		this.locationId = locationId;
		this.zoneId = zoneId;
		this.structureId = structureId;
		this.deviceId = deviceId;
	}
}